import React, {useState, useRef} from 'react'
import ManageDisbursmentHeader from "../../components/Disbursment/ManageDisbursmentHeader";
import { XmlReportList } from '../../components/Reports/XmlReportList';
import Spinner from '../../components/Tools/spinner';
import SubHeader from '../../components/Subheader/Subheader';
import {useSelector} from 'react-redux';
import CustomBreadcrumbs from '../../components/Tools/Breadcumbs';


const XmlReport = () => {
    const [loading, setLoading] = useState(false);
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const {financialYears} = useSelector((state) => state.authData);
    const fyIdRef = useRef(localStorage.getItem('globalDateId'));
    const fyList = financialYears.payload.fy_list;

    const handlePageTrigger = () => {
        fyIdRef.current = localStorage.getItem('globalDateId');
    }


    const handleDateChange = (start, end) => {
        setFromDate(start);
        setToDate(end);

    };
    return (
        <div>
            {loading && <div > <Spinner/> </div>}
            <SubHeader fy_list={fyList} handlePageTrigger={handlePageTrigger}/>
            <div className="row" style={{ padding: "10px 16px" }}>
                <div className="col-md-6">
                    <h4 style={{ color: "#28326f", margin:0}}>IFMS XML Reportings</h4>
                    <CustomBreadcrumbs linksArray={[]} title="IFMS XML Reportings"/>
                </div>
                <div className="col-md-6">
                    
                </div>
            </div>
            <div className='scheme p-3'>
                <XmlReportList setLoading={setLoading}/>
            </div>
        </div>
    )
}

export default XmlReport
